export default function() {
    const faqAccordians = document.querySelectorAll('.cms-content-faqs__button');
    const faqAccordiansLength = faqAccordians.length;
    if (faqAccordiansLength <= 0) {
        return;
    }

    for (let i = 0; i < faqAccordiansLength; i++) {
        faqAccordians[i].addEventListener("click", function() {
            this.classList.toggle("cms-content-faqs__collapsed");

            const answer = this.nextElementSibling;
            if (window.getComputedStyle(answer).display == "block") {
                answer.style.display = "none";
            } else {
                answer.style.display = "block";
            }
        });
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/modules/faqs.js